import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import CustomComponent from '../components/CustomComponent';
import { DAC_DIEM_LIEN_QUAN_BENH_FIELDS, HO_SO_BENH_AN_FORM } from '../../../../../../constants/BenhAn';
import {useDetailHoSoBenhAn, useMedicalRecordFormIO} from '../../../../../../modals/modal-benh-an/hooks/hoSoBenhAn';
import { OctGenerateForm } from '@oceantech/oceantech-ui';
import {usePhanHeKhamBenhContext} from "../../../../../../contexts/PhanHeTiepDonContext";

const BenhAn = (props: any) => {
	const { setFieldValue, values } = useFormikContext<any>();
  const {benhNhanInfo} = usePhanHeKhamBenhContext();

  const benhNhanDieuTri = benhNhanInfo?.thongTinKhamBenh || {}

	const { formJSON } = useMedicalRecordFormIO({
		medicalRecordCode: props.medicalRecordTypeCode,
		formCode: HO_SO_BENH_AN_FORM.TRANG_A,
	});
	const { data: formValues } = useDetailHoSoBenhAn({
		medicalRecordId: benhNhanDieuTri?.encounterIdExec,
		formName: HO_SO_BENH_AN_FORM.TRANG_A,
	});

	useEffect(() => {
		if (formValues) {
			setFieldValue('forms', formValues);
			setFieldValue(
				'dacDiemLienQuanBenhResult',
				getCustomFieldValue(DAC_DIEM_LIEN_QUAN_BENH_FIELDS, formValues)
			);
		}
	}, [formValues]);

	const getCustomFieldValue = (fields: string[], data: any) => {
		const result: Record<string, any> = {};
		fields.forEach((key: string) => {
			result[key] = data[key];
		});
		return result;
	};

	return (
		<OctGenerateForm
			listFieldAuto={formJSON}
			modelID="forms"
			values={values}
			setFieldValue={setFieldValue}
			customComponent={CustomComponent}
		/>
	);
};

export default BenhAn;
